import React from 'react'

const OtherCard = (props) => {
    const {type, name, street, city, pin, country, color} = props
    return (
        <div className="col-lg-4 col-md-6 col-sm-12 col-xl-4">
            <div className="track-card">
                <div className="track-card-heading">
                    {type}
                </div>
                <div className="track-card-body">
                    <div >
                        <p className="track-card-text">{name}</p>
                        <p className="track-card-text">{street}</p>
                        <p className="track-card-text">{city} {pin}</p>
                        <p className="track-card-text">{country}</p>
                    </div>

                </div>
            </div>
            <div className="track-border" style={{backgroundColor:color}}></div>
        </div>
    )
}

export default OtherCard